/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth.index'
import { Route as VerifyTokenRouteImport } from './routes/verify.$token'
import { Route as AuthResetRouteImport } from './routes/auth.reset'
import { Route as AuthInviteRouteImport } from './routes/auth.invite'
import { Route as AuthForgotRouteImport } from './routes/auth.forgot'
import { Route as AuthChangePasswordRouteImport } from './routes/auth.change-password'
import { Route as AuthTeamRouteImport } from './routes/_auth.team'
import { Route as AuthNoAccessRouteImport } from './routes/_auth.no-access'
import { Route as AuthMessagesRouteImport } from './routes/_auth.messages'
import { Route as AuthMeRouteImport } from './routes/_auth.me'
import { Route as AuthMeIndexRouteImport } from './routes/_auth.me.index'
import { Route as AuthTeamPerformanceRouteImport } from './routes/_auth.team.performance'
import { Route as AuthTeamLeavesRouteImport } from './routes/_auth.team.leaves'
import { Route as AuthTeamDirectoryRouteImport } from './routes/_auth.team.directory'
import { Route as AuthTeamAttendanceRouteImport } from './routes/_auth.team.attendance'
import { Route as AuthTeamApprovalsRouteImport } from './routes/_auth.team.approvals'
import { Route as AuthMeTravelRouteImport } from './routes/_auth.me.travel'
import { Route as AuthMeTasksRouteImport } from './routes/_auth.me.tasks'
import { Route as AuthMeShiftsRouteImport } from './routes/_auth.me.shifts'
import { Route as AuthMeRequestsRouteImport } from './routes/_auth.me.requests'
import { Route as AuthMePunchRouteImport } from './routes/_auth.me.punch'
import { Route as AuthMeProfileRouteImport } from './routes/_auth.me.profile'
import { Route as AuthMePreferencesRouteImport } from './routes/_auth.me.preferences'
import { Route as AuthMePersonalRouteImport } from './routes/_auth.me.personal'
import { Route as AuthMePayrollRouteImport } from './routes/_auth.me.payroll'
import { Route as AuthMeOverviewRouteImport } from './routes/_auth.me.overview'
import { Route as AuthMeOvertimeRouteImport } from './routes/_auth.me.overtime'
import { Route as AuthMeNotificationsRouteImport } from './routes/_auth.me.notifications'
import { Route as AuthMeMyLeaveRouteImport } from './routes/_auth.me.my-leave'
import { Route as AuthMeMyAttendanceRouteImport } from './routes/_auth.me.my-attendance'
import { Route as AuthMeLoansRouteImport } from './routes/_auth.me.loans'
import { Route as AuthMeLifecycleRouteImport } from './routes/_auth.me.lifecycle'
import { Route as AuthMeHrLettersRouteImport } from './routes/_auth.me.hr-letters'
import { Route as AuthMeExpensesRouteImport } from './routes/_auth.me.expenses'
import { Route as AuthMeDocumentsRouteImport } from './routes/_auth.me.documents'
import { Route as AuthMeDirectoryRouteImport } from './routes/_auth.me.directory'
import { Route as AuthMeCalendarRouteImport } from './routes/_auth.me.calendar'
import { Route as AuthMeAssistantRouteImport } from './routes/_auth.me.assistant'
import { Route as AuthMeAssetsRouteImport } from './routes/_auth.me.assets'
import { Route as AuthMeTravelIndexRouteImport } from './routes/_auth.me.travel.index'
import { Route as AuthMeTasksIndexRouteImport } from './routes/_auth.me.tasks.index'
import { Route as AuthMeReviewsIndexRouteImport } from './routes/_auth.me.reviews.index'
import { Route as AuthMeRequestsIndexRouteImport } from './routes/_auth.me.requests.index'
import { Route as AuthMeProfileIndexRouteImport } from './routes/_auth.me.profile.index'
import { Route as AuthMeLoansIndexRouteImport } from './routes/_auth.me.loans.index'
import { Route as AuthMeHrLettersIndexRouteImport } from './routes/_auth.me.hr-letters.index'
import { Route as AuthMeExpensesIndexRouteImport } from './routes/_auth.me.expenses.index'
import { Route as AuthMeTravelNewRouteImport } from './routes/_auth.me.travel.new'
import { Route as AuthMeTravelIdRouteImport } from './routes/_auth.me.travel.$id'
import { Route as AuthMeTasksIdRouteImport } from './routes/_auth.me.tasks.$id'
import { Route as AuthMeReviewsReviewIdRouteImport } from './routes/_auth.me.reviews.$reviewId'
import { Route as AuthMeRequestsNewRouteImport } from './routes/_auth.me.requests.new'
import { Route as AuthMeRequestsIdRouteImport } from './routes/_auth.me.requests.$id'
import { Route as AuthMeProfileWorkRouteImport } from './routes/_auth.me.profile.work'
import { Route as AuthMeProfileSecurityRouteImport } from './routes/_auth.me.profile.security'
import { Route as AuthMeProfilePersonalRouteImport } from './routes/_auth.me.profile.personal'
import { Route as AuthMeProfileEmergencyRouteImport } from './routes/_auth.me.profile.emergency'
import { Route as AuthMeProfileDocumentsRouteImport } from './routes/_auth.me.profile.documents'
import { Route as AuthMeProfileBankRouteImport } from './routes/_auth.me.profile.bank'
import { Route as AuthMeLoansNewRouteImport } from './routes/_auth.me.loans.new'
import { Route as AuthMeLoansIdRouteImport } from './routes/_auth.me.loans.$id'
import { Route as AuthMeHrLettersIdRouteImport } from './routes/_auth.me.hr-letters.$id'
import { Route as AuthMeExpensesNewRouteImport } from './routes/_auth.me.expenses.new'
import { Route as AuthMeExpensesIdRouteImport } from './routes/_auth.me.expenses.$id'
import { Route as AuthMeReviewsResultsCycleIdRouteImport } from './routes/_auth.me.reviews.results.$cycleId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const VerifyTokenRoute = VerifyTokenRouteImport.update({
  id: '/verify/$token',
  path: '/verify/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetRoute = AuthResetRouteImport.update({
  id: '/auth/reset',
  path: '/auth/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: '/auth/invite',
  path: '/auth/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/auth/forgot',
  path: '/auth/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/auth/change-password',
  path: '/auth/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTeamRoute = AuthTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNoAccessRoute = AuthNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMessagesRoute = AuthMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeRoute = AuthMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMeIndexRoute = AuthMeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthTeamPerformanceRoute = AuthTeamPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AuthTeamRoute,
} as any)
const AuthTeamLeavesRoute = AuthTeamLeavesRouteImport.update({
  id: '/leaves',
  path: '/leaves',
  getParentRoute: () => AuthTeamRoute,
} as any)
const AuthTeamDirectoryRoute = AuthTeamDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AuthTeamRoute,
} as any)
const AuthTeamAttendanceRoute = AuthTeamAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AuthTeamRoute,
} as any)
const AuthTeamApprovalsRoute = AuthTeamApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthTeamRoute,
} as any)
const AuthMeTravelRoute = AuthMeTravelRouteImport.update({
  id: '/travel',
  path: '/travel',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeTasksRoute = AuthMeTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeShiftsRoute = AuthMeShiftsRouteImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeRequestsRoute = AuthMeRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMePunchRoute = AuthMePunchRouteImport.update({
  id: '/punch',
  path: '/punch',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeProfileRoute = AuthMeProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMePreferencesRoute = AuthMePreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMePersonalRoute = AuthMePersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMePayrollRoute = AuthMePayrollRouteImport.update({
  id: '/payroll',
  path: '/payroll',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeOverviewRoute = AuthMeOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeOvertimeRoute = AuthMeOvertimeRouteImport.update({
  id: '/overtime',
  path: '/overtime',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeNotificationsRoute = AuthMeNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeMyLeaveRoute = AuthMeMyLeaveRouteImport.update({
  id: '/my-leave',
  path: '/my-leave',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeMyAttendanceRoute = AuthMeMyAttendanceRouteImport.update({
  id: '/my-attendance',
  path: '/my-attendance',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeLoansRoute = AuthMeLoansRouteImport.update({
  id: '/loans',
  path: '/loans',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeLifecycleRoute = AuthMeLifecycleRouteImport.update({
  id: '/lifecycle',
  path: '/lifecycle',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeHrLettersRoute = AuthMeHrLettersRouteImport.update({
  id: '/hr-letters',
  path: '/hr-letters',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeExpensesRoute = AuthMeExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeDocumentsRoute = AuthMeDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeDirectoryRoute = AuthMeDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeCalendarRoute = AuthMeCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeAssistantRoute = AuthMeAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AuthMeRoute,
} as any).lazy(() =>
  import('./routes/_auth.me.assistant.lazy').then((d) => d.Route),
)
const AuthMeAssetsRoute = AuthMeAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeTravelIndexRoute = AuthMeTravelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeTravelRoute,
} as any)
const AuthMeTasksIndexRoute = AuthMeTasksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeTasksRoute,
} as any)
const AuthMeReviewsIndexRoute = AuthMeReviewsIndexRouteImport.update({
  id: '/reviews/',
  path: '/reviews/',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeRequestsIndexRoute = AuthMeRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeRequestsRoute,
} as any)
const AuthMeProfileIndexRoute = AuthMeProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeLoansIndexRoute = AuthMeLoansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeLoansRoute,
} as any)
const AuthMeHrLettersIndexRoute = AuthMeHrLettersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeHrLettersRoute,
} as any)
const AuthMeExpensesIndexRoute = AuthMeExpensesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthMeExpensesRoute,
} as any)
const AuthMeTravelNewRoute = AuthMeTravelNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMeTravelRoute,
} as any)
const AuthMeTravelIdRoute = AuthMeTravelIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeTravelRoute,
} as any)
const AuthMeTasksIdRoute = AuthMeTasksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeTasksRoute,
} as any)
const AuthMeReviewsReviewIdRoute = AuthMeReviewsReviewIdRouteImport.update({
  id: '/reviews/$reviewId',
  path: '/reviews/$reviewId',
  getParentRoute: () => AuthMeRoute,
} as any)
const AuthMeRequestsNewRoute = AuthMeRequestsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMeRequestsRoute,
} as any)
const AuthMeRequestsIdRoute = AuthMeRequestsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeRequestsRoute,
} as any)
const AuthMeProfileWorkRoute = AuthMeProfileWorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeProfileSecurityRoute = AuthMeProfileSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeProfilePersonalRoute = AuthMeProfilePersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeProfileEmergencyRoute = AuthMeProfileEmergencyRouteImport.update({
  id: '/emergency',
  path: '/emergency',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeProfileDocumentsRoute = AuthMeProfileDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeProfileBankRoute = AuthMeProfileBankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => AuthMeProfileRoute,
} as any)
const AuthMeLoansNewRoute = AuthMeLoansNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMeLoansRoute,
} as any)
const AuthMeLoansIdRoute = AuthMeLoansIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeLoansRoute,
} as any)
const AuthMeHrLettersIdRoute = AuthMeHrLettersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeHrLettersRoute,
} as any)
const AuthMeExpensesNewRoute = AuthMeExpensesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthMeExpensesRoute,
} as any)
const AuthMeExpensesIdRoute = AuthMeExpensesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthMeExpensesRoute,
} as any)
const AuthMeReviewsResultsCycleIdRoute =
  AuthMeReviewsResultsCycleIdRouteImport.update({
    id: '/reviews/results/$cycleId',
    path: '/reviews/results/$cycleId',
    getParentRoute: () => AuthMeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/me': typeof AuthMeRouteWithChildren
  '/messages': typeof AuthMessagesRoute
  '/no-access': typeof AuthNoAccessRoute
  '/team': typeof AuthTeamRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/me/assets': typeof AuthMeAssetsRoute
  '/me/assistant': typeof AuthMeAssistantRoute
  '/me/calendar': typeof AuthMeCalendarRoute
  '/me/directory': typeof AuthMeDirectoryRoute
  '/me/documents': typeof AuthMeDocumentsRoute
  '/me/expenses': typeof AuthMeExpensesRouteWithChildren
  '/me/hr-letters': typeof AuthMeHrLettersRouteWithChildren
  '/me/lifecycle': typeof AuthMeLifecycleRoute
  '/me/loans': typeof AuthMeLoansRouteWithChildren
  '/me/my-attendance': typeof AuthMeMyAttendanceRoute
  '/me/my-leave': typeof AuthMeMyLeaveRoute
  '/me/notifications': typeof AuthMeNotificationsRoute
  '/me/overtime': typeof AuthMeOvertimeRoute
  '/me/overview': typeof AuthMeOverviewRoute
  '/me/payroll': typeof AuthMePayrollRoute
  '/me/personal': typeof AuthMePersonalRoute
  '/me/preferences': typeof AuthMePreferencesRoute
  '/me/profile': typeof AuthMeProfileRouteWithChildren
  '/me/punch': typeof AuthMePunchRoute
  '/me/requests': typeof AuthMeRequestsRouteWithChildren
  '/me/shifts': typeof AuthMeShiftsRoute
  '/me/tasks': typeof AuthMeTasksRouteWithChildren
  '/me/travel': typeof AuthMeTravelRouteWithChildren
  '/team/approvals': typeof AuthTeamApprovalsRoute
  '/team/attendance': typeof AuthTeamAttendanceRoute
  '/team/directory': typeof AuthTeamDirectoryRoute
  '/team/leaves': typeof AuthTeamLeavesRoute
  '/team/performance': typeof AuthTeamPerformanceRoute
  '/me/': typeof AuthMeIndexRoute
  '/me/expenses/$id': typeof AuthMeExpensesIdRoute
  '/me/expenses/new': typeof AuthMeExpensesNewRoute
  '/me/hr-letters/$id': typeof AuthMeHrLettersIdRoute
  '/me/loans/$id': typeof AuthMeLoansIdRoute
  '/me/loans/new': typeof AuthMeLoansNewRoute
  '/me/profile/bank': typeof AuthMeProfileBankRoute
  '/me/profile/documents': typeof AuthMeProfileDocumentsRoute
  '/me/profile/emergency': typeof AuthMeProfileEmergencyRoute
  '/me/profile/personal': typeof AuthMeProfilePersonalRoute
  '/me/profile/security': typeof AuthMeProfileSecurityRoute
  '/me/profile/work': typeof AuthMeProfileWorkRoute
  '/me/requests/$id': typeof AuthMeRequestsIdRoute
  '/me/requests/new': typeof AuthMeRequestsNewRoute
  '/me/reviews/$reviewId': typeof AuthMeReviewsReviewIdRoute
  '/me/tasks/$id': typeof AuthMeTasksIdRoute
  '/me/travel/$id': typeof AuthMeTravelIdRoute
  '/me/travel/new': typeof AuthMeTravelNewRoute
  '/me/expenses/': typeof AuthMeExpensesIndexRoute
  '/me/hr-letters/': typeof AuthMeHrLettersIndexRoute
  '/me/loans/': typeof AuthMeLoansIndexRoute
  '/me/profile/': typeof AuthMeProfileIndexRoute
  '/me/requests/': typeof AuthMeRequestsIndexRoute
  '/me/reviews/': typeof AuthMeReviewsIndexRoute
  '/me/tasks/': typeof AuthMeTasksIndexRoute
  '/me/travel/': typeof AuthMeTravelIndexRoute
  '/me/reviews/results/$cycleId': typeof AuthMeReviewsResultsCycleIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/messages': typeof AuthMessagesRoute
  '/no-access': typeof AuthNoAccessRoute
  '/team': typeof AuthTeamRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/': typeof AuthIndexRoute
  '/me/assets': typeof AuthMeAssetsRoute
  '/me/assistant': typeof AuthMeAssistantRoute
  '/me/calendar': typeof AuthMeCalendarRoute
  '/me/directory': typeof AuthMeDirectoryRoute
  '/me/documents': typeof AuthMeDocumentsRoute
  '/me/lifecycle': typeof AuthMeLifecycleRoute
  '/me/my-attendance': typeof AuthMeMyAttendanceRoute
  '/me/my-leave': typeof AuthMeMyLeaveRoute
  '/me/notifications': typeof AuthMeNotificationsRoute
  '/me/overtime': typeof AuthMeOvertimeRoute
  '/me/overview': typeof AuthMeOverviewRoute
  '/me/payroll': typeof AuthMePayrollRoute
  '/me/personal': typeof AuthMePersonalRoute
  '/me/preferences': typeof AuthMePreferencesRoute
  '/me/punch': typeof AuthMePunchRoute
  '/me/shifts': typeof AuthMeShiftsRoute
  '/team/approvals': typeof AuthTeamApprovalsRoute
  '/team/attendance': typeof AuthTeamAttendanceRoute
  '/team/directory': typeof AuthTeamDirectoryRoute
  '/team/leaves': typeof AuthTeamLeavesRoute
  '/team/performance': typeof AuthTeamPerformanceRoute
  '/me': typeof AuthMeIndexRoute
  '/me/expenses/$id': typeof AuthMeExpensesIdRoute
  '/me/expenses/new': typeof AuthMeExpensesNewRoute
  '/me/hr-letters/$id': typeof AuthMeHrLettersIdRoute
  '/me/loans/$id': typeof AuthMeLoansIdRoute
  '/me/loans/new': typeof AuthMeLoansNewRoute
  '/me/profile/bank': typeof AuthMeProfileBankRoute
  '/me/profile/documents': typeof AuthMeProfileDocumentsRoute
  '/me/profile/emergency': typeof AuthMeProfileEmergencyRoute
  '/me/profile/personal': typeof AuthMeProfilePersonalRoute
  '/me/profile/security': typeof AuthMeProfileSecurityRoute
  '/me/profile/work': typeof AuthMeProfileWorkRoute
  '/me/requests/$id': typeof AuthMeRequestsIdRoute
  '/me/requests/new': typeof AuthMeRequestsNewRoute
  '/me/reviews/$reviewId': typeof AuthMeReviewsReviewIdRoute
  '/me/tasks/$id': typeof AuthMeTasksIdRoute
  '/me/travel/$id': typeof AuthMeTravelIdRoute
  '/me/travel/new': typeof AuthMeTravelNewRoute
  '/me/expenses': typeof AuthMeExpensesIndexRoute
  '/me/hr-letters': typeof AuthMeHrLettersIndexRoute
  '/me/loans': typeof AuthMeLoansIndexRoute
  '/me/profile': typeof AuthMeProfileIndexRoute
  '/me/requests': typeof AuthMeRequestsIndexRoute
  '/me/reviews': typeof AuthMeReviewsIndexRoute
  '/me/tasks': typeof AuthMeTasksIndexRoute
  '/me/travel': typeof AuthMeTravelIndexRoute
  '/me/reviews/results/$cycleId': typeof AuthMeReviewsResultsCycleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/me': typeof AuthMeRouteWithChildren
  '/_auth/messages': typeof AuthMessagesRoute
  '/_auth/no-access': typeof AuthNoAccessRoute
  '/_auth/team': typeof AuthTeamRouteWithChildren
  '/auth/change-password': typeof AuthChangePasswordRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/invite': typeof AuthInviteRoute
  '/auth/reset': typeof AuthResetRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/me/assets': typeof AuthMeAssetsRoute
  '/_auth/me/assistant': typeof AuthMeAssistantRoute
  '/_auth/me/calendar': typeof AuthMeCalendarRoute
  '/_auth/me/directory': typeof AuthMeDirectoryRoute
  '/_auth/me/documents': typeof AuthMeDocumentsRoute
  '/_auth/me/expenses': typeof AuthMeExpensesRouteWithChildren
  '/_auth/me/hr-letters': typeof AuthMeHrLettersRouteWithChildren
  '/_auth/me/lifecycle': typeof AuthMeLifecycleRoute
  '/_auth/me/loans': typeof AuthMeLoansRouteWithChildren
  '/_auth/me/my-attendance': typeof AuthMeMyAttendanceRoute
  '/_auth/me/my-leave': typeof AuthMeMyLeaveRoute
  '/_auth/me/notifications': typeof AuthMeNotificationsRoute
  '/_auth/me/overtime': typeof AuthMeOvertimeRoute
  '/_auth/me/overview': typeof AuthMeOverviewRoute
  '/_auth/me/payroll': typeof AuthMePayrollRoute
  '/_auth/me/personal': typeof AuthMePersonalRoute
  '/_auth/me/preferences': typeof AuthMePreferencesRoute
  '/_auth/me/profile': typeof AuthMeProfileRouteWithChildren
  '/_auth/me/punch': typeof AuthMePunchRoute
  '/_auth/me/requests': typeof AuthMeRequestsRouteWithChildren
  '/_auth/me/shifts': typeof AuthMeShiftsRoute
  '/_auth/me/tasks': typeof AuthMeTasksRouteWithChildren
  '/_auth/me/travel': typeof AuthMeTravelRouteWithChildren
  '/_auth/team/approvals': typeof AuthTeamApprovalsRoute
  '/_auth/team/attendance': typeof AuthTeamAttendanceRoute
  '/_auth/team/directory': typeof AuthTeamDirectoryRoute
  '/_auth/team/leaves': typeof AuthTeamLeavesRoute
  '/_auth/team/performance': typeof AuthTeamPerformanceRoute
  '/_auth/me/': typeof AuthMeIndexRoute
  '/_auth/me/expenses/$id': typeof AuthMeExpensesIdRoute
  '/_auth/me/expenses/new': typeof AuthMeExpensesNewRoute
  '/_auth/me/hr-letters/$id': typeof AuthMeHrLettersIdRoute
  '/_auth/me/loans/$id': typeof AuthMeLoansIdRoute
  '/_auth/me/loans/new': typeof AuthMeLoansNewRoute
  '/_auth/me/profile/bank': typeof AuthMeProfileBankRoute
  '/_auth/me/profile/documents': typeof AuthMeProfileDocumentsRoute
  '/_auth/me/profile/emergency': typeof AuthMeProfileEmergencyRoute
  '/_auth/me/profile/personal': typeof AuthMeProfilePersonalRoute
  '/_auth/me/profile/security': typeof AuthMeProfileSecurityRoute
  '/_auth/me/profile/work': typeof AuthMeProfileWorkRoute
  '/_auth/me/requests/$id': typeof AuthMeRequestsIdRoute
  '/_auth/me/requests/new': typeof AuthMeRequestsNewRoute
  '/_auth/me/reviews/$reviewId': typeof AuthMeReviewsReviewIdRoute
  '/_auth/me/tasks/$id': typeof AuthMeTasksIdRoute
  '/_auth/me/travel/$id': typeof AuthMeTravelIdRoute
  '/_auth/me/travel/new': typeof AuthMeTravelNewRoute
  '/_auth/me/expenses/': typeof AuthMeExpensesIndexRoute
  '/_auth/me/hr-letters/': typeof AuthMeHrLettersIndexRoute
  '/_auth/me/loans/': typeof AuthMeLoansIndexRoute
  '/_auth/me/profile/': typeof AuthMeProfileIndexRoute
  '/_auth/me/requests/': typeof AuthMeRequestsIndexRoute
  '/_auth/me/reviews/': typeof AuthMeReviewsIndexRoute
  '/_auth/me/tasks/': typeof AuthMeTasksIndexRoute
  '/_auth/me/travel/': typeof AuthMeTravelIndexRoute
  '/_auth/me/reviews/results/$cycleId': typeof AuthMeReviewsResultsCycleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/me'
    | '/messages'
    | '/no-access'
    | '/team'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/verify/$token'
    | '/me/assets'
    | '/me/assistant'
    | '/me/calendar'
    | '/me/directory'
    | '/me/documents'
    | '/me/expenses'
    | '/me/hr-letters'
    | '/me/lifecycle'
    | '/me/loans'
    | '/me/my-attendance'
    | '/me/my-leave'
    | '/me/notifications'
    | '/me/overtime'
    | '/me/overview'
    | '/me/payroll'
    | '/me/personal'
    | '/me/preferences'
    | '/me/profile'
    | '/me/punch'
    | '/me/requests'
    | '/me/shifts'
    | '/me/tasks'
    | '/me/travel'
    | '/team/approvals'
    | '/team/attendance'
    | '/team/directory'
    | '/team/leaves'
    | '/team/performance'
    | '/me/'
    | '/me/expenses/$id'
    | '/me/expenses/new'
    | '/me/hr-letters/$id'
    | '/me/loans/$id'
    | '/me/loans/new'
    | '/me/profile/bank'
    | '/me/profile/documents'
    | '/me/profile/emergency'
    | '/me/profile/personal'
    | '/me/profile/security'
    | '/me/profile/work'
    | '/me/requests/$id'
    | '/me/requests/new'
    | '/me/reviews/$reviewId'
    | '/me/tasks/$id'
    | '/me/travel/$id'
    | '/me/travel/new'
    | '/me/expenses/'
    | '/me/hr-letters/'
    | '/me/loans/'
    | '/me/profile/'
    | '/me/requests/'
    | '/me/reviews/'
    | '/me/tasks/'
    | '/me/travel/'
    | '/me/reviews/results/$cycleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/messages'
    | '/no-access'
    | '/team'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/verify/$token'
    | '/'
    | '/me/assets'
    | '/me/assistant'
    | '/me/calendar'
    | '/me/directory'
    | '/me/documents'
    | '/me/lifecycle'
    | '/me/my-attendance'
    | '/me/my-leave'
    | '/me/notifications'
    | '/me/overtime'
    | '/me/overview'
    | '/me/payroll'
    | '/me/personal'
    | '/me/preferences'
    | '/me/punch'
    | '/me/shifts'
    | '/team/approvals'
    | '/team/attendance'
    | '/team/directory'
    | '/team/leaves'
    | '/team/performance'
    | '/me'
    | '/me/expenses/$id'
    | '/me/expenses/new'
    | '/me/hr-letters/$id'
    | '/me/loans/$id'
    | '/me/loans/new'
    | '/me/profile/bank'
    | '/me/profile/documents'
    | '/me/profile/emergency'
    | '/me/profile/personal'
    | '/me/profile/security'
    | '/me/profile/work'
    | '/me/requests/$id'
    | '/me/requests/new'
    | '/me/reviews/$reviewId'
    | '/me/tasks/$id'
    | '/me/travel/$id'
    | '/me/travel/new'
    | '/me/expenses'
    | '/me/hr-letters'
    | '/me/loans'
    | '/me/profile'
    | '/me/requests'
    | '/me/reviews'
    | '/me/tasks'
    | '/me/travel'
    | '/me/reviews/results/$cycleId'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/me'
    | '/_auth/messages'
    | '/_auth/no-access'
    | '/_auth/team'
    | '/auth/change-password'
    | '/auth/forgot'
    | '/auth/invite'
    | '/auth/reset'
    | '/verify/$token'
    | '/_auth/'
    | '/_auth/me/assets'
    | '/_auth/me/assistant'
    | '/_auth/me/calendar'
    | '/_auth/me/directory'
    | '/_auth/me/documents'
    | '/_auth/me/expenses'
    | '/_auth/me/hr-letters'
    | '/_auth/me/lifecycle'
    | '/_auth/me/loans'
    | '/_auth/me/my-attendance'
    | '/_auth/me/my-leave'
    | '/_auth/me/notifications'
    | '/_auth/me/overtime'
    | '/_auth/me/overview'
    | '/_auth/me/payroll'
    | '/_auth/me/personal'
    | '/_auth/me/preferences'
    | '/_auth/me/profile'
    | '/_auth/me/punch'
    | '/_auth/me/requests'
    | '/_auth/me/shifts'
    | '/_auth/me/tasks'
    | '/_auth/me/travel'
    | '/_auth/team/approvals'
    | '/_auth/team/attendance'
    | '/_auth/team/directory'
    | '/_auth/team/leaves'
    | '/_auth/team/performance'
    | '/_auth/me/'
    | '/_auth/me/expenses/$id'
    | '/_auth/me/expenses/new'
    | '/_auth/me/hr-letters/$id'
    | '/_auth/me/loans/$id'
    | '/_auth/me/loans/new'
    | '/_auth/me/profile/bank'
    | '/_auth/me/profile/documents'
    | '/_auth/me/profile/emergency'
    | '/_auth/me/profile/personal'
    | '/_auth/me/profile/security'
    | '/_auth/me/profile/work'
    | '/_auth/me/requests/$id'
    | '/_auth/me/requests/new'
    | '/_auth/me/reviews/$reviewId'
    | '/_auth/me/tasks/$id'
    | '/_auth/me/travel/$id'
    | '/_auth/me/travel/new'
    | '/_auth/me/expenses/'
    | '/_auth/me/hr-letters/'
    | '/_auth/me/loans/'
    | '/_auth/me/profile/'
    | '/_auth/me/requests/'
    | '/_auth/me/reviews/'
    | '/_auth/me/tasks/'
    | '/_auth/me/travel/'
    | '/_auth/me/reviews/results/$cycleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthForgotRoute: typeof AuthForgotRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthResetRoute: typeof AuthResetRoute
  VerifyTokenRoute: typeof VerifyTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/verify/$token': {
      id: '/verify/$token'
      path: '/verify/$token'
      fullPath: '/verify/$token'
      preLoaderRoute: typeof VerifyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset': {
      id: '/auth/reset'
      path: '/auth/reset'
      fullPath: '/auth/reset'
      preLoaderRoute: typeof AuthResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/invite': {
      id: '/auth/invite'
      path: '/auth/invite'
      fullPath: '/auth/invite'
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/auth/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/change-password': {
      id: '/auth/change-password'
      path: '/auth/change-password'
      fullPath: '/auth/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/team': {
      id: '/_auth/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthTeamRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/no-access': {
      id: '/_auth/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthNoAccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/messages': {
      id: '/_auth/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AuthMessagesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me': {
      id: '/_auth/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AuthMeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/me/': {
      id: '/_auth/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof AuthMeIndexRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/team/performance': {
      id: '/_auth/team/performance'
      path: '/performance'
      fullPath: '/team/performance'
      preLoaderRoute: typeof AuthTeamPerformanceRouteImport
      parentRoute: typeof AuthTeamRoute
    }
    '/_auth/team/leaves': {
      id: '/_auth/team/leaves'
      path: '/leaves'
      fullPath: '/team/leaves'
      preLoaderRoute: typeof AuthTeamLeavesRouteImport
      parentRoute: typeof AuthTeamRoute
    }
    '/_auth/team/directory': {
      id: '/_auth/team/directory'
      path: '/directory'
      fullPath: '/team/directory'
      preLoaderRoute: typeof AuthTeamDirectoryRouteImport
      parentRoute: typeof AuthTeamRoute
    }
    '/_auth/team/attendance': {
      id: '/_auth/team/attendance'
      path: '/attendance'
      fullPath: '/team/attendance'
      preLoaderRoute: typeof AuthTeamAttendanceRouteImport
      parentRoute: typeof AuthTeamRoute
    }
    '/_auth/team/approvals': {
      id: '/_auth/team/approvals'
      path: '/approvals'
      fullPath: '/team/approvals'
      preLoaderRoute: typeof AuthTeamApprovalsRouteImport
      parentRoute: typeof AuthTeamRoute
    }
    '/_auth/me/travel': {
      id: '/_auth/me/travel'
      path: '/travel'
      fullPath: '/me/travel'
      preLoaderRoute: typeof AuthMeTravelRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/tasks': {
      id: '/_auth/me/tasks'
      path: '/tasks'
      fullPath: '/me/tasks'
      preLoaderRoute: typeof AuthMeTasksRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/shifts': {
      id: '/_auth/me/shifts'
      path: '/shifts'
      fullPath: '/me/shifts'
      preLoaderRoute: typeof AuthMeShiftsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/requests': {
      id: '/_auth/me/requests'
      path: '/requests'
      fullPath: '/me/requests'
      preLoaderRoute: typeof AuthMeRequestsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/punch': {
      id: '/_auth/me/punch'
      path: '/punch'
      fullPath: '/me/punch'
      preLoaderRoute: typeof AuthMePunchRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/profile': {
      id: '/_auth/me/profile'
      path: '/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AuthMeProfileRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/preferences': {
      id: '/_auth/me/preferences'
      path: '/preferences'
      fullPath: '/me/preferences'
      preLoaderRoute: typeof AuthMePreferencesRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/personal': {
      id: '/_auth/me/personal'
      path: '/personal'
      fullPath: '/me/personal'
      preLoaderRoute: typeof AuthMePersonalRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/payroll': {
      id: '/_auth/me/payroll'
      path: '/payroll'
      fullPath: '/me/payroll'
      preLoaderRoute: typeof AuthMePayrollRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/overview': {
      id: '/_auth/me/overview'
      path: '/overview'
      fullPath: '/me/overview'
      preLoaderRoute: typeof AuthMeOverviewRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/overtime': {
      id: '/_auth/me/overtime'
      path: '/overtime'
      fullPath: '/me/overtime'
      preLoaderRoute: typeof AuthMeOvertimeRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/notifications': {
      id: '/_auth/me/notifications'
      path: '/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof AuthMeNotificationsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/my-leave': {
      id: '/_auth/me/my-leave'
      path: '/my-leave'
      fullPath: '/me/my-leave'
      preLoaderRoute: typeof AuthMeMyLeaveRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/my-attendance': {
      id: '/_auth/me/my-attendance'
      path: '/my-attendance'
      fullPath: '/me/my-attendance'
      preLoaderRoute: typeof AuthMeMyAttendanceRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/loans': {
      id: '/_auth/me/loans'
      path: '/loans'
      fullPath: '/me/loans'
      preLoaderRoute: typeof AuthMeLoansRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/lifecycle': {
      id: '/_auth/me/lifecycle'
      path: '/lifecycle'
      fullPath: '/me/lifecycle'
      preLoaderRoute: typeof AuthMeLifecycleRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/hr-letters': {
      id: '/_auth/me/hr-letters'
      path: '/hr-letters'
      fullPath: '/me/hr-letters'
      preLoaderRoute: typeof AuthMeHrLettersRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/expenses': {
      id: '/_auth/me/expenses'
      path: '/expenses'
      fullPath: '/me/expenses'
      preLoaderRoute: typeof AuthMeExpensesRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/documents': {
      id: '/_auth/me/documents'
      path: '/documents'
      fullPath: '/me/documents'
      preLoaderRoute: typeof AuthMeDocumentsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/directory': {
      id: '/_auth/me/directory'
      path: '/directory'
      fullPath: '/me/directory'
      preLoaderRoute: typeof AuthMeDirectoryRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/calendar': {
      id: '/_auth/me/calendar'
      path: '/calendar'
      fullPath: '/me/calendar'
      preLoaderRoute: typeof AuthMeCalendarRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/assistant': {
      id: '/_auth/me/assistant'
      path: '/assistant'
      fullPath: '/me/assistant'
      preLoaderRoute: typeof AuthMeAssistantRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/assets': {
      id: '/_auth/me/assets'
      path: '/assets'
      fullPath: '/me/assets'
      preLoaderRoute: typeof AuthMeAssetsRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/travel/': {
      id: '/_auth/me/travel/'
      path: '/'
      fullPath: '/me/travel/'
      preLoaderRoute: typeof AuthMeTravelIndexRouteImport
      parentRoute: typeof AuthMeTravelRoute
    }
    '/_auth/me/tasks/': {
      id: '/_auth/me/tasks/'
      path: '/'
      fullPath: '/me/tasks/'
      preLoaderRoute: typeof AuthMeTasksIndexRouteImport
      parentRoute: typeof AuthMeTasksRoute
    }
    '/_auth/me/reviews/': {
      id: '/_auth/me/reviews/'
      path: '/reviews'
      fullPath: '/me/reviews/'
      preLoaderRoute: typeof AuthMeReviewsIndexRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/requests/': {
      id: '/_auth/me/requests/'
      path: '/'
      fullPath: '/me/requests/'
      preLoaderRoute: typeof AuthMeRequestsIndexRouteImport
      parentRoute: typeof AuthMeRequestsRoute
    }
    '/_auth/me/profile/': {
      id: '/_auth/me/profile/'
      path: '/'
      fullPath: '/me/profile/'
      preLoaderRoute: typeof AuthMeProfileIndexRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/loans/': {
      id: '/_auth/me/loans/'
      path: '/'
      fullPath: '/me/loans/'
      preLoaderRoute: typeof AuthMeLoansIndexRouteImport
      parentRoute: typeof AuthMeLoansRoute
    }
    '/_auth/me/hr-letters/': {
      id: '/_auth/me/hr-letters/'
      path: '/'
      fullPath: '/me/hr-letters/'
      preLoaderRoute: typeof AuthMeHrLettersIndexRouteImport
      parentRoute: typeof AuthMeHrLettersRoute
    }
    '/_auth/me/expenses/': {
      id: '/_auth/me/expenses/'
      path: '/'
      fullPath: '/me/expenses/'
      preLoaderRoute: typeof AuthMeExpensesIndexRouteImport
      parentRoute: typeof AuthMeExpensesRoute
    }
    '/_auth/me/travel/new': {
      id: '/_auth/me/travel/new'
      path: '/new'
      fullPath: '/me/travel/new'
      preLoaderRoute: typeof AuthMeTravelNewRouteImport
      parentRoute: typeof AuthMeTravelRoute
    }
    '/_auth/me/travel/$id': {
      id: '/_auth/me/travel/$id'
      path: '/$id'
      fullPath: '/me/travel/$id'
      preLoaderRoute: typeof AuthMeTravelIdRouteImport
      parentRoute: typeof AuthMeTravelRoute
    }
    '/_auth/me/tasks/$id': {
      id: '/_auth/me/tasks/$id'
      path: '/$id'
      fullPath: '/me/tasks/$id'
      preLoaderRoute: typeof AuthMeTasksIdRouteImport
      parentRoute: typeof AuthMeTasksRoute
    }
    '/_auth/me/reviews/$reviewId': {
      id: '/_auth/me/reviews/$reviewId'
      path: '/reviews/$reviewId'
      fullPath: '/me/reviews/$reviewId'
      preLoaderRoute: typeof AuthMeReviewsReviewIdRouteImport
      parentRoute: typeof AuthMeRoute
    }
    '/_auth/me/requests/new': {
      id: '/_auth/me/requests/new'
      path: '/new'
      fullPath: '/me/requests/new'
      preLoaderRoute: typeof AuthMeRequestsNewRouteImport
      parentRoute: typeof AuthMeRequestsRoute
    }
    '/_auth/me/requests/$id': {
      id: '/_auth/me/requests/$id'
      path: '/$id'
      fullPath: '/me/requests/$id'
      preLoaderRoute: typeof AuthMeRequestsIdRouteImport
      parentRoute: typeof AuthMeRequestsRoute
    }
    '/_auth/me/profile/work': {
      id: '/_auth/me/profile/work'
      path: '/work'
      fullPath: '/me/profile/work'
      preLoaderRoute: typeof AuthMeProfileWorkRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/profile/security': {
      id: '/_auth/me/profile/security'
      path: '/security'
      fullPath: '/me/profile/security'
      preLoaderRoute: typeof AuthMeProfileSecurityRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/profile/personal': {
      id: '/_auth/me/profile/personal'
      path: '/personal'
      fullPath: '/me/profile/personal'
      preLoaderRoute: typeof AuthMeProfilePersonalRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/profile/emergency': {
      id: '/_auth/me/profile/emergency'
      path: '/emergency'
      fullPath: '/me/profile/emergency'
      preLoaderRoute: typeof AuthMeProfileEmergencyRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/profile/documents': {
      id: '/_auth/me/profile/documents'
      path: '/documents'
      fullPath: '/me/profile/documents'
      preLoaderRoute: typeof AuthMeProfileDocumentsRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/profile/bank': {
      id: '/_auth/me/profile/bank'
      path: '/bank'
      fullPath: '/me/profile/bank'
      preLoaderRoute: typeof AuthMeProfileBankRouteImport
      parentRoute: typeof AuthMeProfileRoute
    }
    '/_auth/me/loans/new': {
      id: '/_auth/me/loans/new'
      path: '/new'
      fullPath: '/me/loans/new'
      preLoaderRoute: typeof AuthMeLoansNewRouteImport
      parentRoute: typeof AuthMeLoansRoute
    }
    '/_auth/me/loans/$id': {
      id: '/_auth/me/loans/$id'
      path: '/$id'
      fullPath: '/me/loans/$id'
      preLoaderRoute: typeof AuthMeLoansIdRouteImport
      parentRoute: typeof AuthMeLoansRoute
    }
    '/_auth/me/hr-letters/$id': {
      id: '/_auth/me/hr-letters/$id'
      path: '/$id'
      fullPath: '/me/hr-letters/$id'
      preLoaderRoute: typeof AuthMeHrLettersIdRouteImport
      parentRoute: typeof AuthMeHrLettersRoute
    }
    '/_auth/me/expenses/new': {
      id: '/_auth/me/expenses/new'
      path: '/new'
      fullPath: '/me/expenses/new'
      preLoaderRoute: typeof AuthMeExpensesNewRouteImport
      parentRoute: typeof AuthMeExpensesRoute
    }
    '/_auth/me/expenses/$id': {
      id: '/_auth/me/expenses/$id'
      path: '/$id'
      fullPath: '/me/expenses/$id'
      preLoaderRoute: typeof AuthMeExpensesIdRouteImport
      parentRoute: typeof AuthMeExpensesRoute
    }
    '/_auth/me/reviews/results/$cycleId': {
      id: '/_auth/me/reviews/results/$cycleId'
      path: '/reviews/results/$cycleId'
      fullPath: '/me/reviews/results/$cycleId'
      preLoaderRoute: typeof AuthMeReviewsResultsCycleIdRouteImport
      parentRoute: typeof AuthMeRoute
    }
  }
}

interface AuthMeExpensesRouteChildren {
  AuthMeExpensesIdRoute: typeof AuthMeExpensesIdRoute
  AuthMeExpensesNewRoute: typeof AuthMeExpensesNewRoute
  AuthMeExpensesIndexRoute: typeof AuthMeExpensesIndexRoute
}

const AuthMeExpensesRouteChildren: AuthMeExpensesRouteChildren = {
  AuthMeExpensesIdRoute: AuthMeExpensesIdRoute,
  AuthMeExpensesNewRoute: AuthMeExpensesNewRoute,
  AuthMeExpensesIndexRoute: AuthMeExpensesIndexRoute,
}

const AuthMeExpensesRouteWithChildren = AuthMeExpensesRoute._addFileChildren(
  AuthMeExpensesRouteChildren,
)

interface AuthMeHrLettersRouteChildren {
  AuthMeHrLettersIdRoute: typeof AuthMeHrLettersIdRoute
  AuthMeHrLettersIndexRoute: typeof AuthMeHrLettersIndexRoute
}

const AuthMeHrLettersRouteChildren: AuthMeHrLettersRouteChildren = {
  AuthMeHrLettersIdRoute: AuthMeHrLettersIdRoute,
  AuthMeHrLettersIndexRoute: AuthMeHrLettersIndexRoute,
}

const AuthMeHrLettersRouteWithChildren = AuthMeHrLettersRoute._addFileChildren(
  AuthMeHrLettersRouteChildren,
)

interface AuthMeLoansRouteChildren {
  AuthMeLoansIdRoute: typeof AuthMeLoansIdRoute
  AuthMeLoansNewRoute: typeof AuthMeLoansNewRoute
  AuthMeLoansIndexRoute: typeof AuthMeLoansIndexRoute
}

const AuthMeLoansRouteChildren: AuthMeLoansRouteChildren = {
  AuthMeLoansIdRoute: AuthMeLoansIdRoute,
  AuthMeLoansNewRoute: AuthMeLoansNewRoute,
  AuthMeLoansIndexRoute: AuthMeLoansIndexRoute,
}

const AuthMeLoansRouteWithChildren = AuthMeLoansRoute._addFileChildren(
  AuthMeLoansRouteChildren,
)

interface AuthMeProfileRouteChildren {
  AuthMeProfileBankRoute: typeof AuthMeProfileBankRoute
  AuthMeProfileDocumentsRoute: typeof AuthMeProfileDocumentsRoute
  AuthMeProfileEmergencyRoute: typeof AuthMeProfileEmergencyRoute
  AuthMeProfilePersonalRoute: typeof AuthMeProfilePersonalRoute
  AuthMeProfileSecurityRoute: typeof AuthMeProfileSecurityRoute
  AuthMeProfileWorkRoute: typeof AuthMeProfileWorkRoute
  AuthMeProfileIndexRoute: typeof AuthMeProfileIndexRoute
}

const AuthMeProfileRouteChildren: AuthMeProfileRouteChildren = {
  AuthMeProfileBankRoute: AuthMeProfileBankRoute,
  AuthMeProfileDocumentsRoute: AuthMeProfileDocumentsRoute,
  AuthMeProfileEmergencyRoute: AuthMeProfileEmergencyRoute,
  AuthMeProfilePersonalRoute: AuthMeProfilePersonalRoute,
  AuthMeProfileSecurityRoute: AuthMeProfileSecurityRoute,
  AuthMeProfileWorkRoute: AuthMeProfileWorkRoute,
  AuthMeProfileIndexRoute: AuthMeProfileIndexRoute,
}

const AuthMeProfileRouteWithChildren = AuthMeProfileRoute._addFileChildren(
  AuthMeProfileRouteChildren,
)

interface AuthMeRequestsRouteChildren {
  AuthMeRequestsIdRoute: typeof AuthMeRequestsIdRoute
  AuthMeRequestsNewRoute: typeof AuthMeRequestsNewRoute
  AuthMeRequestsIndexRoute: typeof AuthMeRequestsIndexRoute
}

const AuthMeRequestsRouteChildren: AuthMeRequestsRouteChildren = {
  AuthMeRequestsIdRoute: AuthMeRequestsIdRoute,
  AuthMeRequestsNewRoute: AuthMeRequestsNewRoute,
  AuthMeRequestsIndexRoute: AuthMeRequestsIndexRoute,
}

const AuthMeRequestsRouteWithChildren = AuthMeRequestsRoute._addFileChildren(
  AuthMeRequestsRouteChildren,
)

interface AuthMeTasksRouteChildren {
  AuthMeTasksIdRoute: typeof AuthMeTasksIdRoute
  AuthMeTasksIndexRoute: typeof AuthMeTasksIndexRoute
}

const AuthMeTasksRouteChildren: AuthMeTasksRouteChildren = {
  AuthMeTasksIdRoute: AuthMeTasksIdRoute,
  AuthMeTasksIndexRoute: AuthMeTasksIndexRoute,
}

const AuthMeTasksRouteWithChildren = AuthMeTasksRoute._addFileChildren(
  AuthMeTasksRouteChildren,
)

interface AuthMeTravelRouteChildren {
  AuthMeTravelIdRoute: typeof AuthMeTravelIdRoute
  AuthMeTravelNewRoute: typeof AuthMeTravelNewRoute
  AuthMeTravelIndexRoute: typeof AuthMeTravelIndexRoute
}

const AuthMeTravelRouteChildren: AuthMeTravelRouteChildren = {
  AuthMeTravelIdRoute: AuthMeTravelIdRoute,
  AuthMeTravelNewRoute: AuthMeTravelNewRoute,
  AuthMeTravelIndexRoute: AuthMeTravelIndexRoute,
}

const AuthMeTravelRouteWithChildren = AuthMeTravelRoute._addFileChildren(
  AuthMeTravelRouteChildren,
)

interface AuthMeRouteChildren {
  AuthMeAssetsRoute: typeof AuthMeAssetsRoute
  AuthMeAssistantRoute: typeof AuthMeAssistantRoute
  AuthMeCalendarRoute: typeof AuthMeCalendarRoute
  AuthMeDirectoryRoute: typeof AuthMeDirectoryRoute
  AuthMeDocumentsRoute: typeof AuthMeDocumentsRoute
  AuthMeExpensesRoute: typeof AuthMeExpensesRouteWithChildren
  AuthMeHrLettersRoute: typeof AuthMeHrLettersRouteWithChildren
  AuthMeLifecycleRoute: typeof AuthMeLifecycleRoute
  AuthMeLoansRoute: typeof AuthMeLoansRouteWithChildren
  AuthMeMyAttendanceRoute: typeof AuthMeMyAttendanceRoute
  AuthMeMyLeaveRoute: typeof AuthMeMyLeaveRoute
  AuthMeNotificationsRoute: typeof AuthMeNotificationsRoute
  AuthMeOvertimeRoute: typeof AuthMeOvertimeRoute
  AuthMeOverviewRoute: typeof AuthMeOverviewRoute
  AuthMePayrollRoute: typeof AuthMePayrollRoute
  AuthMePersonalRoute: typeof AuthMePersonalRoute
  AuthMePreferencesRoute: typeof AuthMePreferencesRoute
  AuthMeProfileRoute: typeof AuthMeProfileRouteWithChildren
  AuthMePunchRoute: typeof AuthMePunchRoute
  AuthMeRequestsRoute: typeof AuthMeRequestsRouteWithChildren
  AuthMeShiftsRoute: typeof AuthMeShiftsRoute
  AuthMeTasksRoute: typeof AuthMeTasksRouteWithChildren
  AuthMeTravelRoute: typeof AuthMeTravelRouteWithChildren
  AuthMeIndexRoute: typeof AuthMeIndexRoute
  AuthMeReviewsReviewIdRoute: typeof AuthMeReviewsReviewIdRoute
  AuthMeReviewsIndexRoute: typeof AuthMeReviewsIndexRoute
  AuthMeReviewsResultsCycleIdRoute: typeof AuthMeReviewsResultsCycleIdRoute
}

const AuthMeRouteChildren: AuthMeRouteChildren = {
  AuthMeAssetsRoute: AuthMeAssetsRoute,
  AuthMeAssistantRoute: AuthMeAssistantRoute,
  AuthMeCalendarRoute: AuthMeCalendarRoute,
  AuthMeDirectoryRoute: AuthMeDirectoryRoute,
  AuthMeDocumentsRoute: AuthMeDocumentsRoute,
  AuthMeExpensesRoute: AuthMeExpensesRouteWithChildren,
  AuthMeHrLettersRoute: AuthMeHrLettersRouteWithChildren,
  AuthMeLifecycleRoute: AuthMeLifecycleRoute,
  AuthMeLoansRoute: AuthMeLoansRouteWithChildren,
  AuthMeMyAttendanceRoute: AuthMeMyAttendanceRoute,
  AuthMeMyLeaveRoute: AuthMeMyLeaveRoute,
  AuthMeNotificationsRoute: AuthMeNotificationsRoute,
  AuthMeOvertimeRoute: AuthMeOvertimeRoute,
  AuthMeOverviewRoute: AuthMeOverviewRoute,
  AuthMePayrollRoute: AuthMePayrollRoute,
  AuthMePersonalRoute: AuthMePersonalRoute,
  AuthMePreferencesRoute: AuthMePreferencesRoute,
  AuthMeProfileRoute: AuthMeProfileRouteWithChildren,
  AuthMePunchRoute: AuthMePunchRoute,
  AuthMeRequestsRoute: AuthMeRequestsRouteWithChildren,
  AuthMeShiftsRoute: AuthMeShiftsRoute,
  AuthMeTasksRoute: AuthMeTasksRouteWithChildren,
  AuthMeTravelRoute: AuthMeTravelRouteWithChildren,
  AuthMeIndexRoute: AuthMeIndexRoute,
  AuthMeReviewsReviewIdRoute: AuthMeReviewsReviewIdRoute,
  AuthMeReviewsIndexRoute: AuthMeReviewsIndexRoute,
  AuthMeReviewsResultsCycleIdRoute: AuthMeReviewsResultsCycleIdRoute,
}

const AuthMeRouteWithChildren =
  AuthMeRoute._addFileChildren(AuthMeRouteChildren)

interface AuthTeamRouteChildren {
  AuthTeamApprovalsRoute: typeof AuthTeamApprovalsRoute
  AuthTeamAttendanceRoute: typeof AuthTeamAttendanceRoute
  AuthTeamDirectoryRoute: typeof AuthTeamDirectoryRoute
  AuthTeamLeavesRoute: typeof AuthTeamLeavesRoute
  AuthTeamPerformanceRoute: typeof AuthTeamPerformanceRoute
}

const AuthTeamRouteChildren: AuthTeamRouteChildren = {
  AuthTeamApprovalsRoute: AuthTeamApprovalsRoute,
  AuthTeamAttendanceRoute: AuthTeamAttendanceRoute,
  AuthTeamDirectoryRoute: AuthTeamDirectoryRoute,
  AuthTeamLeavesRoute: AuthTeamLeavesRoute,
  AuthTeamPerformanceRoute: AuthTeamPerformanceRoute,
}

const AuthTeamRouteWithChildren = AuthTeamRoute._addFileChildren(
  AuthTeamRouteChildren,
)

interface AuthRouteChildren {
  AuthMeRoute: typeof AuthMeRouteWithChildren
  AuthMessagesRoute: typeof AuthMessagesRoute
  AuthNoAccessRoute: typeof AuthNoAccessRoute
  AuthTeamRoute: typeof AuthTeamRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMeRoute: AuthMeRouteWithChildren,
  AuthMessagesRoute: AuthMessagesRoute,
  AuthNoAccessRoute: AuthNoAccessRoute,
  AuthTeamRoute: AuthTeamRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthForgotRoute: AuthForgotRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthResetRoute: AuthResetRoute,
  VerifyTokenRoute: VerifyTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
